import { render, staticRenderFns } from "./ProductPropertyTemplateGroupList.vue?vue&type=template&id=28628a9c"
import script from "./ProductPropertyTemplateGroupList.vue?vue&type=script&lang=js"
export * from "./ProductPropertyTemplateGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports